import { useEventHandler } from "@/shared/base/hooks/useEventHandler";
import { constants } from "../config/constants";
import { useInventoryPreview } from "@/shared/modules/PurchaseSeats/InventoryPreview/useInventoryPreview";

export function GlobalEventListenerContainer() {
  const inventoryPreview = useInventoryPreview();

  // listening for auth completed and completing inventory preview checkout
  useEventHandler({
    name: constants.customEvents.authCompleted,
    handler: inventoryPreview.onCompleteAuth,
  });

  return <></>;
}
